import { useMutation, useQueryClient } from "@tanstack/react-query";

import { invalidateSkillCollectionVersionQueries } from "./cache-utils";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface DeleteSkillCollectionLabelParams {
  workspaceId: number;
  collectionId: string;
  labelId: number;
}

export const useDeleteSkillCollectionLabel = () => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ labelId }: DeleteSkillCollectionLabelParams) => {
      const res = await fetch(ENDPOINTS.skill_collections.label(labelId), {
        method: "DELETE",
        headers: jsonAuthHeaders(userToken),
      });
      return handleResponse(res);
    },
    onSuccess: (_, variables) => {
      invalidateSkillCollectionVersionQueries(queryClient, variables);
    },
  });
};
